import client from '@/Apollo';
import { GetCustomerInformation } from '../../../../utils/GraphQL';

const getCustomerInfo = () => new Promise((resolve, reject) => {
  client
    .query({
      query: GetCustomerInformation,
    })
    .then((r) => {
      resolve(r.data.MeCustomer);
    })
    .catch((e) => {
      console.log(e.message, 'erro ao buscar');
      reject(e.message);
    });
});

export default getCustomerInfo;
